import { styled } from 'styled-components';

import useLeftSideBar from './hooks/useLeftSideBar';
import { Blocks } from 'types';
import TabBar from './components/TabBar/TabBar';
import SearchBar from './components/SearchBar';
import DataMenu from './components/DataMenu';
import LayerMenu from './components/LayerMenu/LayerMenu';
import ModelMenu from './components/ModelMenu';

const Container = styled.aside<{ $isMenuHide: boolean }>`
  display: flex;
  height: 100%;

  ${(props) => {
    if (!props.$isMenuHide) {
      return {
        borderRight: `1px solid ${props.theme.global.borderColor}`,
      };
    }
  }}
`;

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 290px;
  max-width: 290px;
  flex: 1;
`;

const MenuView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
`;

interface LeftSideBarProps {
  blocks: Blocks;
}

const LeftSideBar = ({ blocks }: LeftSideBarProps) => {
  const { keyword, lowerKeyword, selectedTab, isMenuHide, onKeywordChange, onMenuHideButtonClick, onTabClick } =
    useLeftSideBar();

  return (
    <Container $isMenuHide={isMenuHide}>
      <TabBar
        selectedTab={selectedTab}
        isMenuHide={isMenuHide}
        onMenuHideButtonClick={onMenuHideButtonClick}
        onTabClick={onTabClick}
      />
      {!isMenuHide && (
        <MenuContainer>
          <SearchBar keyword={keyword} onChange={onKeywordChange} />
          <MenuView>
            {selectedTab === 'data' && <DataMenu keyword={lowerKeyword} blocks={blocks['data']} />}
            {selectedTab === 'layer' && <LayerMenu keyword={lowerKeyword} blocks={blocks['layer']} />}
            {selectedTab === 'model' && <ModelMenu keyword={lowerKeyword} blocks={blocks['model']} />}
          </MenuView>
        </MenuContainer>
      )}
    </Container>
  );
};

export default LeftSideBar;
